import firebase from "firebase/app";
import "firebase/auth";
import "firebase/storage";
import "firebase/firestore";

const config = {
  apiKey: "AIzaSyCOuNNjijL4B9eI2bchd0uBAW3Je-CqzuQ",
  authDomain: "qikbytes.firebaseapp.com",
  databaseURL: "https://qikbytes.firebaseio.com",
  projectId: "qikbytes",
  storageBucket: "qikbytes.appspot.com",
  messagingSenderId: "585784188454",
  appId: "1:585784188454:web:2809f9c89a72ff03"
};

// Export plain firebase object to be used for certain static methods like:
//  - Persistance
//  - GoogleAuthProvider
export const FirebaseConsts = firebase;
export default firebase.initializeApp(config);

export const db = firebase.firestore();
export const Storage = firebase.storage();
db.settings({
  timestampsInSnapshots: true
});



// WEBPACK FOOTER //
// ./src/firebaseConfig.js